import { IconButtonProps } from '@chakra-ui/react';
import IconButton from '~/components/IconButton';
import { CaretLeftIcon } from '~/components/icons';

interface Props extends Omit<IconButtonProps, 'onClick'> {
  activeStepIndex: number;
  onClick: (index: number) => void;
}

export const StepperFormBackButton: React.FC<Props> = ({
  activeStepIndex,
  onClick,
  ...iconButtonProps
}) => {
  if (activeStepIndex > 0) {
    return (
      <IconButton
        {...iconButtonProps}
        color="primary.500"
        boxSize={6}
        icon={<CaretLeftIcon />}
        onClick={() => onClick(activeStepIndex - 1)}
      />
    );
  }

  return null;
};
